import type { BadgeProps } from '@shared/ui';
import type { NotificationType } from '@entities/notification';

const TYPE_TONE: Record<NotificationType, NonNullable<BadgeProps['tone']>> = {
  WELCOME: 'primary',
  EMAIL_VERIFIED: 'success',
  USER_BLOCKED: 'danger',
  KYC_APPROVED: 'success',
  KYC_REJECTED: 'danger',
  RFQ_RECEIVED: 'info',
  QUOTE_RECEIVED: 'info',
  QUOTE_ACCEPTED: 'success',
  ORDER_STATUS_CHANGED: 'warning',
  CHAT_MESSAGE: 'info',
  SYSTEM: 'neutral',
};

export function notificationTone(type: NotificationType): NonNullable<BadgeProps['tone']> {
  return TYPE_TONE[type] ?? 'neutral';
}

/** i18n key for the badge label — consumers call t() with the resulting key. */
export function notificationLabelKey(type: NotificationType): string {
  return `notifications.types.${type}`;
}
